const ComponentTypes = {

    DEFAULT:'DEFAULT',
    USER_RESPONSE:'USER_RESPONSE',
    CURRENT_BILL_PLAN:'CURRENT_BILL_PLAN',
    DATA_BALANCE:'DATA_BALANCE',
    OUTSTANDING:'OUTSTANDING',
    MONTHLY_PLAN:'MONTHLY_PLAN',
    IR_PACK:'IR_PACK',
    LOGIN_COMPONENT:'LOGIN_COMPONENT',
    HISTORY_DATE_COMPONENT:'HISTORY_DATE_COMPONENT',
    WELCOME_COMPONENT_MULTIPLE:'WELCOME_COMPONENT_MULTIPLE',
    PREV_DUPLICATE_BILLS:'PREV_DUPLICATE_BILLS',
    PREV_PAYMENT_RECEIPTS:'PREV_PAYMENT_RECEIPTS',
    IR_PACK_DEACTIVATION:'IR_PACK_DEACTIVATION',
    SWITCH_ACCOUNT_MESSAGE:'SWITCH_ACCOUNT_MESSAGE'

}

export default ComponentTypes


// WEBPACK FOOTER //
// ./src/enums/ComponentTypes.js